const SENSITIVE_KEY = /(password|token|authorization|secret)/i;

export const redactSensitiveData = (value) => {
  if (Array.isArray(value)) return value.map(redactSensitiveData);
  if (!value || typeof value !== 'object') return value;

  return Object.entries(value).reduce((redacted, [key, entry]) => {
    redacted[key] = SENSITIVE_KEY.test(key) ? '[Filtered]' : redactSensitiveData(entry);
    return redacted;
  }, {});
};
